var _defs, _g, _g2, _g3, _path, _g4, _g5, _g6, _path2, _g7, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconBestValue2024 = function SvgIconBestValue2024(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    height: 200,
    viewBox: "0 0 150 150"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "IconBestValue2024_svg__c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75 0C33.578 0 0 33.578 0 75s33.578 75 75 75 75-33.578 75-75S116.422 0 75 0m0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "IconBestValue2024_svg__e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 8h134v134H8Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "IconBestValue2024_svg__f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-13.738 42.703 121.035-56.441 56.441 121.035-121.035 56.441Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "IconBestValue2024_svg__g"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.781 14.48c-33.426 15.586-47.883 55.317-32.3 88.739 15.585 33.426 55.316 47.883 88.738 32.3 33.426-15.585 47.886-55.316 32.3-88.738-15.585-33.426-55.316-47.886-88.738-32.3m0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "IconBestValue2024_svg__h"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-13.738 42.703 121.035-56.441 56.441 121.035-121.035 56.441Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "IconBestValue2024_svg__i"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-13.738 42.703 121.035-56.441 56.441 121.035-121.035 56.441Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "IconBestValue2024_svg__k"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 8h134v134H8Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "IconBestValue2024_svg__l"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-13.738 42.703 120.992-56.422 56.422 120.992-120.992 56.422Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "IconBestValue2024_svg__m"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-13.738 42.703 121.035-56.441 56.437 121.035-121.03 56.437Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "IconBestValue2024_svg__n"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.781 14.48c-33.426 15.586-47.883 55.317-32.3 88.739 15.585 33.422 55.316 47.883 88.738 32.297s47.883-55.313 32.297-88.735C119.93 13.355 80.203-1.102 46.78 14.481m0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "IconBestValue2024_svg__o"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.168 118.5h5.25v4.5h-5.25Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "IconBestValue2024_svg__p"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.762 118.5h5.25v4.5h-5.25Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "IconBestValue2024_svg__q"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.762 118.5H93v4.5h-5.238Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "IconBestValue2024_svg__r"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.012 25h15.297v14.93H41.012Zm0 0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "IconBestValue2024_svg__d",
    x1: 0,
    x2: 256,
    y1: 128,
    y2: 128,
    gradientTransform: "matrix(.58594 0 0 .58594 0 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.008
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.016,
    stopColor: "#010101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.023,
    stopColor: "#010101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.031,
    stopColor: "#020202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.039,
    stopColor: "#030303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.047,
    stopColor: "#030303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.055,
    stopColor: "#040404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.063,
    stopColor: "#040404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#050505"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.078,
    stopColor: "#060505"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.086,
    stopColor: "#060606"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.094,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.102,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.109,
    stopColor: "#080808"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.117,
    stopColor: "#080808"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#090909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.133,
    stopColor: "#0A0A0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.141,
    stopColor: "#0A0A0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.148,
    stopColor: "#0B0B0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.156,
    stopColor: "#0B0B0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.164,
    stopColor: "#0C0C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.172,
    stopColor: "#0D0C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0D0D0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188,
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195,
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203,
    stopColor: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.211,
    stopColor: "#100F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.219,
    stopColor: "#101010"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.227,
    stopColor: "#111010"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#111"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.242,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.258,
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.266,
    stopColor: "#141313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.273,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.281,
    stopColor: "#151515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.289,
    stopColor: "#151515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.297,
    stopColor: "#161616"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.305,
    stopColor: "#171616"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.313,
    stopColor: "#171717"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#181717"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328,
    stopColor: "#181818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.336,
    stopColor: "#191919"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.344,
    stopColor: "#191919"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.352,
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359,
    stopColor: "#1B1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.367,
    stopColor: "#1B1B1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#1C1B1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.383,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.391,
    stopColor: "#1D1D1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.398,
    stopColor: "#1E1D1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.406,
    stopColor: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414,
    stopColor: "#1F1E1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.422,
    stopColor: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#201F1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.438,
    stopColor: "#212020"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.445,
    stopColor: "#212121"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453,
    stopColor: "#222121"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461,
    stopColor: "#222"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    stopColor: "#232222"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.477,
    stopColor: "#232323"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484,
    stopColor: "#242424"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492,
    stopColor: "#252424"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#252525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.508,
    stopColor: "#262525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.516,
    stopColor: "#262626"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523,
    stopColor: "#272626"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531,
    stopColor: "#282727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539,
    stopColor: "#282828"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.547,
    stopColor: "#292828"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.555,
    stopColor: "#292929"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.563,
    stopColor: "#2A2929"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#2A2A2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578,
    stopColor: "#2B2A2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.586,
    stopColor: "#2C2B2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#2C2C2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.602,
    stopColor: "#2D2C2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609,
    stopColor: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617,
    stopColor: "#2E2D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#2F2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.633,
    stopColor: "#2F2F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.641,
    stopColor: "#302F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648,
    stopColor: "#303030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.656,
    stopColor: "#313030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664,
    stopColor: "#313131"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.672,
    stopColor: "#323131"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#333232"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.688,
    stopColor: "#333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695,
    stopColor: "#343333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703,
    stopColor: "#343434"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.711,
    stopColor: "#353434"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.719,
    stopColor: "#363535"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727,
    stopColor: "#363535"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734,
    stopColor: "#373636"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742,
    stopColor: "#373737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#383737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.758,
    stopColor: "#393838"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.766,
    stopColor: "#393838"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773,
    stopColor: "#3A3939"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.781,
    stopColor: "#3A3939"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.789,
    stopColor: "#3B3A3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.797,
    stopColor: "#3B3B3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.805,
    stopColor: "#3C3B3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.813,
    stopColor: "#3D3C3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#3D3C3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828,
    stopColor: "#3E3D3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.836,
    stopColor: "#3E3E3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.844,
    stopColor: "#3F3E3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.852,
    stopColor: "#403F3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859,
    stopColor: "#403F3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867,
    stopColor: "#414040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#414040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.883,
    stopColor: "#424141"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.891,
    stopColor: "#424242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898,
    stopColor: "#434242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.906,
    stopColor: "#444343"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.914,
    stopColor: "#444343"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.922,
    stopColor: "#454444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#454444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.938,
    stopColor: "#464545"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.945,
    stopColor: "#474646"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.953,
    stopColor: "#474646"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.961,
    stopColor: "#484747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#484747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.977,
    stopColor: "#494848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984,
    stopColor: "#4A4949"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.992,
    stopColor: "#4A4949"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B4A4A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "IconBestValue2024_svg__j",
    x1: -63.058,
    x2: 319.056,
    y1: 128,
    y2: 128,
    gradientTransform: "scale(.52167)rotate(-25 171.445 100.32)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.156
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.172
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.176,
    stopColor: "#010101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#020202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.184,
    stopColor: "#020202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188,
    stopColor: "#030303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.191,
    stopColor: "#030303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195,
    stopColor: "#040404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.199,
    stopColor: "#040404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203,
    stopColor: "#050505"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.207,
    stopColor: "#050505"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.211,
    stopColor: "#060606"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.215,
    stopColor: "#060606"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.219,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.223,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.227,
    stopColor: "#080808"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#080808"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#090909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.238,
    stopColor: "#0A0909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.242,
    stopColor: "#0A0A0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#0B0A0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#0B0B0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.254,
    stopColor: "#0C0B0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.258,
    stopColor: "#0C0C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.262,
    stopColor: "#0D0C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.266,
    stopColor: "#0D0D0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#0E0D0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.273,
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.277,
    stopColor: "#0F0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.281,
    stopColor: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.285,
    stopColor: "#100F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.289,
    stopColor: "#101010"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.293,
    stopColor: "#111010"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.297,
    stopColor: "#111"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.301,
    stopColor: "#121111"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.305,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.309,
    stopColor: "#131212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.313,
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.316,
    stopColor: "#141313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.324,
    stopColor: "#151414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328,
    stopColor: "#151515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.332,
    stopColor: "#161515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.336,
    stopColor: "#161616"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#171616"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.344,
    stopColor: "#171717"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.348,
    stopColor: "#181717"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.352,
    stopColor: "#181818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    stopColor: "#191818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359,
    stopColor: "#191919"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.363,
    stopColor: "#1A1919"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.367,
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.371,
    stopColor: "#1B1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#1B1B1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.379,
    stopColor: "#1C1B1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.383,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.387,
    stopColor: "#1D1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.391,
    stopColor: "#1D1D1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395,
    stopColor: "#1E1D1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.398,
    stopColor: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.402,
    stopColor: "#1F1E1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.406,
    stopColor: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#201F1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414,
    stopColor: "#202020"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.418,
    stopColor: "#212020"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.422,
    stopColor: "#212121"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.426,
    stopColor: "#222121"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#222"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.434,
    stopColor: "#232222"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.438,
    stopColor: "#232323"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.441,
    stopColor: "#242323"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.445,
    stopColor: "#242424"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.449,
    stopColor: "#252424"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453,
    stopColor: "#252525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.457,
    stopColor: "#262525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461,
    stopColor: "#262626"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.465,
    stopColor: "#272626"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    stopColor: "#272727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.473,
    stopColor: "#282727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.477,
    stopColor: "#282828"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#292828"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484,
    stopColor: "#292929"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488,
    stopColor: "#2A2929"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492,
    stopColor: "#2A2A2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.496,
    stopColor: "#2B2A2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#2B2B2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504,
    stopColor: "#2C2B2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.508,
    stopColor: "#2C2C2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512,
    stopColor: "#2D2C2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.516,
    stopColor: "#2E2D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#2E2D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523,
    stopColor: "#2F2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.527,
    stopColor: "#2F2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531,
    stopColor: "#302F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#302F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539,
    stopColor: "#313030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.543,
    stopColor: "#313030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.547,
    stopColor: "#323131"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.551,
    stopColor: "#323131"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.555,
    stopColor: "#333232"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559,
    stopColor: "#333232"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.563,
    stopColor: "#343333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.566,
    stopColor: "#343333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#353434"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.574,
    stopColor: "#353434"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578,
    stopColor: "#363535"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.582,
    stopColor: "#363535"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.586,
    stopColor: "#373636"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#373636"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#383737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.598,
    stopColor: "#383737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.602,
    stopColor: "#393838"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.605,
    stopColor: "#393838"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609,
    stopColor: "#3A3939"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.613,
    stopColor: "#3A3939"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617,
    stopColor: "#3B3A3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.621,
    stopColor: "#3B3A3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#3C3B3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.629,
    stopColor: "#3C3C3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.633,
    stopColor: "#3D3C3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.637,
    stopColor: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.641,
    stopColor: "#3E3D3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.645,
    stopColor: "#3E3E3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648,
    stopColor: "#3F3E3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.652,
    stopColor: "#3F3F3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.656,
    stopColor: "#403F3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#404040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664,
    stopColor: "#414040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.668,
    stopColor: "#414141"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.672,
    stopColor: "#424141"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.676,
    stopColor: "#424242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#434242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.684,
    stopColor: "#434343"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.688,
    stopColor: "#444343"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.691,
    stopColor: "#444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695,
    stopColor: "#454444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.699,
    stopColor: "#454545"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703,
    stopColor: "#464545"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.707,
    stopColor: "#464646"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.711,
    stopColor: "#474646"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.715,
    stopColor: "#474747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.719,
    stopColor: "#484747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.723,
    stopColor: "#484848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727,
    stopColor: "#494848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#494949"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734,
    stopColor: "#4A4949"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.738,
    stopColor: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742,
    stopColor: "#4B4A4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746,
    stopColor: "#4B4B4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#4C4B4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.754,
    stopColor: "#4C4C4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.758,
    stopColor: "#4D4C4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.762,
    stopColor: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.766,
    stopColor: "#4E4D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#4E4E4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773,
    stopColor: "#4F4E4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.777,
    stopColor: "#4F4F4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.781,
    stopColor: "#504F4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.785,
    stopColor: "#505050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.789,
    stopColor: "#515050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.793,
    stopColor: "#525151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.797,
    stopColor: "#525151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801,
    stopColor: "#535252"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.805,
    stopColor: "#535252"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.809,
    stopColor: "#545353"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.813,
    stopColor: "#545353"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.816,
    stopColor: "#555454"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#555454"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.824,
    stopColor: "#565555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828,
    stopColor: "#565555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.844,
    stopColor: "#575555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#575656"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#575656"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "IconBestValue2024_svg__a",
    width: "100%",
    height: "100%",
    x: "0%",
    y: "0%"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    colorInterpolationFilters: "sRGB",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "IconBestValue2024_svg__b",
    width: "100%",
    height: "100%",
    x: "0%",
    y: "0%"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    colorInterpolationFilters: "sRGB",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0.2126 0.7152 0.0722 0 0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "IconBestValue2024_svg__s"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#IconBestValue2024_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#IconBestValue2024_svg__b)",
    transform: "matrix(.17284 0 0 .17241 41.01 24.93)"
  }, /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,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",
    width: 394,
    height: 87
  })))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#IconBestValue2024_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#IconBestValue2024_svg__d)",
    d: "M-15-15h180v180H-15z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#IconBestValue2024_svg__e)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#IconBestValue2024_svg__f)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#IconBestValue2024_svg__g)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#IconBestValue2024_svg__h)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#IconBestValue2024_svg__i)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#IconBestValue2024_svg__j)",
    d: "m-57.453 26.79 84.242 180.663 180.664-84.242-84.242-180.664Zm0 0"
  }))))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#IconBestValue2024_svg__k)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#IconBestValue2024_svg__l)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#IconBestValue2024_svg__m)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#IconBestValue2024_svg__n)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.5,
    d: "M46.781 14.48c-33.426 15.586-47.883 55.317-32.3 88.739 15.585 33.422 55.316 47.883 88.738 32.297s47.883-55.313 32.297-88.735C119.93 13.355 80.203-1.102 46.78 14.481Zm0 0"
  })))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.75,
    d: "M15 103.5h120M15 46.5h120"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    clipPath: "url(#IconBestValue2024_svg__o)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m59.8 118.52.81 1.472 1.808.235-1.309 1.148.309 1.621-1.617-.766-1.621.766.308-1.621-1.308-1.148 1.812-.235Zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m59.79 118.504.808 1.473 1.808.238-1.308 1.148.308 1.617-1.617-.761-1.621.761.312-1.617-1.312-1.148 1.809-.238Zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m59.79 118.504.808 1.473 1.808.238-1.308 1.148.308 1.617-1.617-.761-1.621.761.312-1.617-1.312-1.148 1.809-.238Zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m59.79 118.504.808 1.473 1.808.238-1.308 1.148.308 1.617-1.617-.761-1.621.761.312-1.617-1.312-1.148 1.809-.238Zm0 0"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#IconBestValue2024_svg__p)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m90.39 118.52.81 1.472 1.812.235-1.313 1.148.313 1.621-1.621-.766-1.618.766.309-1.621-1.309-1.148 1.809-.235Zm0 0"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    clipPath: "url(#IconBestValue2024_svg__q)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m90.379 118.504.808 1.473 1.813.238-1.312 1.148.308 1.617-1.617-.761-1.617.761.308-1.617-1.308-1.148 1.808-.238Zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m90.379 118.504.808 1.473 1.813.238-1.312 1.148.308 1.617-1.617-.761-1.617.761.308-1.617-1.308-1.148 1.808-.238Zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m90.379 118.504.808 1.473 1.813.238-1.312 1.148.308 1.617-1.617-.761-1.617.761.308-1.617-1.308-1.148 1.808-.238Zm0 0"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M43.434 65.947q0 .55-.328 1.047-.316.486-1 .75.89.234 1.359.89.468.645.469 1.313 0 1.254-.844 2.11-.846.843-2.234.843h-4.141v-9.64h3.86q1.294 0 2.077.734.781.722.782 1.953m-4.672 1.11h1.61a.84.84 0 0 0 .64-.266q.264-.28.265-.72 0-.466-.234-.734-.236-.28-.687-.28h-1.594Zm1.937 1.702h-1.937v2.328h1.984q.48.001.75-.343.282-.358.281-.844-.002-.435-.296-.781-.283-.36-.782-.36M45.631 72.9v-9.64h6.094v1.796h-4.063v2.203h3.563v1.782h-3.563v2.046h4.188V72.9ZM53.162 70.072h2.062q.031.487.407.828.375.328 1.03.328.641.002 1.017-.266a.93.93 0 0 0 .406-.75.85.85 0 0 0-.235-.625q-.253-.263-.921-.468l-1.172-.328q-2.485-.762-2.485-2.766 0-1.265.953-2.078.951-.811 2.36-.813c.945 0 1.726.274 2.344.813q.92.797.921 2.156h-2.046q0-.498-.329-.797c-.21-.195-.515-.297-.921-.297q-.552 0-.891.282-.345.269-.344.671 0 .692 1.031.985l1.141.36c1.813.53 2.695 1.507 2.656 2.921a2.56 2.56 0 0 1-.547 1.578 2.96 2.96 0 0 1-1.28.953c-.5.196-1.056.297-1.657.297-1.043 0-1.887-.273-2.531-.828q-.972-.843-.97-2.156M61.09 65.103V63.26h7.28v1.844h-2.609V72.9H63.7v-7.797ZM72.395 63.26h2.14l1.72 6.327 1.702-6.328h2.141L77.16 72.9h-1.828ZM83.947 68.837h2l-1.015-3.359Zm2.657 1.782h-3.329l-.859 2.281h-2.172l3.578-9.64h2.219l3.578 9.64h-2.156ZM90.687 72.9v-9.64h2.047v7.827h3.61V72.9ZM100.308 70.65c.332.305.723.453 1.172.453q.668 0 1.172-.469.499-.468.5-1.172V63.26h2.062v6.203q-.002 1.596-1.094 2.594-1.094.985-2.64.985-1.535 0-2.64-.985c-.743-.664-1.11-1.531-1.11-2.594V63.26h2.094v6.203q-.001.72.484 1.188M107.385 72.9v-9.64h6.094v1.796h-4.063v2.203h3.563v1.782h-3.563v2.046h4.188V72.9ZM46.1 78.856h-1.858v2.719h1.812q.563 0 .89-.422a1.5 1.5 0 0 0 .329-.937q-.001-.5-.313-.922a1.01 1.01 0 0 0-.86-.438M42.196 86.7v-9.64h3.953q1.56 0 2.375.937.81.924.812 2.219-.002 1.299-.812 2.234-.815.924-2.375.922h-1.906V86.7ZM54.632 78.856h-1.796v2.719h1.734q.563 0 .89-.422a1.5 1.5 0 0 0 .329-.937q-.001-.5-.313-.922a1 1 0 0 0-.844-.438m.891 4.422L57.93 86.7h-2.468l-2.157-3.328h-.468V86.7h-2.047v-9.64h3.937c1.031 0 1.82.312 2.375.937q.827.924.828 2.219 0 1.113-.609 1.968c-.406.563-1.008.93-1.797 1.094M62.002 79.825q-.814.86-.813 2.078 0 1.219.813 2.063.825.843 2.015.843 1.2 0 2.031-.843.828-.855.829-2.063-.001-1.218-.829-2.078a2.73 2.73 0 0 0-2.03-.86 2.7 2.7 0 0 0-2.016.86m-2.86 2.078q0-2.062 1.422-3.516 1.419-1.453 3.453-1.453 2.061 0 3.485 1.453 1.42 1.454 1.421 3.516 0 2.033-1.437 3.484-1.424 1.454-3.469 1.454-2.034 0-3.453-1.454-1.424-1.451-1.422-3.484M69.714 77.06h2.141l1.719 6.327 1.703-6.328h2.14L74.48 86.7h-1.828ZM78.782 77.06h2.032v9.64h-2.032ZM85.125 78.919v5.922h1.734q1.106 0 1.703-.844c.406-.563.61-1.258.61-2.094q0-1.278-.61-2.125c-.398-.57-.965-.86-1.703-.86Zm1.734 7.781h-3.766v-9.64h3.766q2.028 0 3.188 1.359 1.17 1.361 1.171 3.484 0 2.11-1.171 3.453c-.774.899-1.836 1.344-3.188 1.344M92.99 86.7v-9.64h6.093v1.796H95.02v2.203h3.563v1.782H95.02v2.046h4.188V86.7ZM104.895 78.856h-1.797v2.719h1.735q.563 0 .89-.422a1.5 1.5 0 0 0 .328-.937q0-.5-.312-.922a1 1 0 0 0-.844-.438m.89 4.422 2.407 3.422h-2.469l-2.156-3.328h-.469V86.7h-2.047v-9.64h3.938c1.031 0 1.82.312 2.375.937q.826.924.828 2.219 0 1.113-.61 1.968-.61.846-1.796 1.094M68.283 123.92h-4.25v-.766l2.688-3.187q.341-.388.343-.734a.58.58 0 0 0-.218-.454c-.149-.132-.344-.203-.594-.203s-.461.09-.625.266a1.12 1.12 0 0 0-.313.64l-1.28-.218c.1-.625.358-1.117.765-1.485q.607-.545 1.531-.546.89 0 1.516.562c.414.375.625.855.625 1.438q0 .877-.688 1.656l-1.516 1.719h2.016ZM69.575 120.639q-.001-3.406 2.453-3.406.686.001 1.172.265.497.27.765.75.264.47.375 1.063c.07.386.11.828.11 1.328s-.04.945-.11 1.328a3.6 3.6 0 0 1-.375 1.062q-.269.47-.765.735-.486.248-1.172.25-2.454 0-2.453-3.375m1.406 0q0 2.016 1.047 2.015 1.03 0 1.031-2.015 0-2.03-1.031-2.031c-.7 0-1.047.68-1.047 2.03M79.801 123.92h-4.25v-.766l2.688-3.187c.226-.258.344-.504.344-.734a.58.58 0 0 0-.22-.454c-.148-.132-.343-.203-.593-.203q-.376.001-.625.266a1.12 1.12 0 0 0-.312.64l-1.282-.218c.102-.625.36-1.117.766-1.485q.607-.545 1.531-.546.89 0 1.516.562c.414.375.625.855.625 1.438q0 .877-.688 1.656l-1.515 1.719H79.8ZM82.609 121.264h1.218v-2.031Zm3.468 1.187h-.828v1.469h-1.422v-1.469h-3.125l3.063-5.078h1.484v3.89h.828Zm0 0"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#IconBestValue2024_svg__r)",
    mask: "url(#IconBestValue2024_svg__s)"
  }, /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,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",
    width: 394,
    height: 87,
    transform: "matrix(.17284 0 0 .17241 41.01 24.93)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M62.818 29.87h-1.172v1.703h1.14a.67.67 0 0 0 .563-.265.97.97 0 0 0 .203-.594.96.96 0 0 0-.203-.578.62.62 0 0 0-.531-.266m-2.453 4.922V28.73h2.484q.968.001 1.485.593.515.58.515 1.407 0 .815-.515 1.39-.517.58-1.485.578h-1.203v2.094ZM68.173 29.87h-1.125v1.703h1.094a.67.67 0 0 0 .563-.265.97.97 0 0 0 .203-.594.96.96 0 0 0-.203-.578.62.62 0 0 0-.532-.266m.563 2.781 1.516 2.141h-1.547l-1.36-2.094h-.297v2.094h-1.28V28.73h2.468q.967.001 1.484.593c.352.387.532.852.532 1.391q-.002.706-.391 1.234-.375.534-1.125.703M72.81 30.48q-.516.534-.516 1.296 0 .77.515 1.297.528.533 1.266.532.75.001 1.266-.532.528-.546.53-1.297-.002-.761-.53-1.296a1.68 1.68 0 0 0-1.266-.547 1.7 1.7 0 0 0-1.266.547m-1.798 1.296q0-1.294.891-2.203c.594-.601 1.32-.906 2.188-.906.851 0 1.578.305 2.171.906.602.606.907 1.34.907 2.203 0 .856-.305 1.59-.907 2.204q-.891.907-2.187.906-1.282.002-2.172-.906a3.06 3.06 0 0 1-.89-2.204M83.087 28.73l-1.906 2.828 2.11 3.234h-1.532l-1.344-2.203-1.344 2.203h-1.515l2.094-3.234-1.907-2.828h1.547l1.125 1.812 1.14-1.812ZM86.83 34.792h-1.313v-2.75L83.19 28.73h1.531l1.453 2.265 1.485-2.265h1.531l-2.36 3.328Zm0 0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m94.26 32.542 1.188-3.812h1.406l-2.062 6.062h-1.016l-.844-3.187-.843 3.187h-1.016l-2.047-6.062h1.39l1.188 3.812q.154-.563.813-2.953h1.047ZM99.118 32.245h1.25l-.64-2.11Zm1.672 1.11h-2.093l-.547 1.437h-1.36l2.25-6.062h1.39l2.25 6.062h-1.358ZM106.15 34.792h-1.312v-2.75l-2.328-3.312h1.532l1.453 2.265 1.484-2.265h1.531l-2.36 3.328Zm0 0"
  })));
};
export default SvgIconBestValue2024;